export const environment = {
  production: false,
  activate_log: 'true',
  piste_base_url: 'ADP_PISTEBASEURL',
  piste_hab_base_url : 'ADP_HAB_PISTEBASEURL',
  redirection_context_base_url: 'ADP_REDIRECTION_CONTEXT_PISTEBASEURL',
  log_level: 'INFO',
  log_classes: ['ChoixFormulaireComponent',
    'StepperComponent',
    'ChoixSupportComponent',
    'FormulaireServiceService'],
  local: false,
  authentication_required: 'ADP_AUTHENTICATION_REQUIRED',
  oidc_enabled: 'ADP_OIDC_ENABLED',
  profile: 'ADP_PROFILE',
  only_payload: 'ADP_ONLY_PAYLOAD',
  facturation: 'ADP_FACTURATION',
  check_facturation: 'ADP_FACTURATION_CHECK',
  check_idWeb: 'ADP_IDWEB_CHECK',
  check_announcer: 'ADP_ANNOUNCER_CHECK',
  shal_enabled: 'ADP_SHAL_ENABLED',
  form_ad_enabled: 'ADP_FORM_AD_ENABLED',
  uri_prefix : 'ADP_URI_PREFIX',
  pref : 'ADP_PREF',
  formsEnabled: 'ADP_FORMS_ENABLED',
  siteId: 'ADP_SITE_ID',
  waf: 'false',
  convert_error_waf: {
    double_point: ':',
    point_point: '[.]',
    u_nion:'union'
  },
  deconvert_error_waf: {
    double_point: ':',
    point_point: '.',
    u_nion:'union'
  }
};
